import { render, staticRenderFns } from "./ProjectCommentArea.vue?vue&type=template&id=fc615bf2&scoped=true&"
import script from "./ProjectCommentArea.vue?vue&type=script&lang=js&"
export * from "./ProjectCommentArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc615bf2",
  null
  
)

export default component.exports